import { useState } from 'react'
import { emailCampaignFields as fields, getClassNameForField } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { useParams } from 'react-router-dom'
import { Button } from '../../shared/components/Button'
import { FaEye, FaTrash } from 'react-icons/fa'
import { FaEyeSlash } from 'react-icons/fa6'
import { useDeleteItem } from '../../util/deleteItem'
import ConfirmDeleteModal from '../components/DeleteModal'
import { useTranslation } from 'react-i18next'
import { useTranslationService } from '../../util/TranslationContext'

const NewsletterCampaignSlug = () => {
    const [preview, setPreview] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)

    const { t } = useTranslation()
    const { id } = useParams()

    const { translateFields } = useTranslationService()
    const emailCampaignFields = translateFields(fields, 'newsletter')

    const deleteItem = useDeleteItem()
    const handleDelete = async () => {
        await deleteItem({
            url: `admin/newsletter-campaigns/${id}`,
            navigateSuccess: '/admin/auth/newsletter-campaigns',
            onError: msg => alert(msg),
        })
    }

    return (
        <>
            <div className='flex items-center justify-between'>
                <Button variant='primary' className='mb-4' onClick={() => setPreview(!preview)}>
                    {!preview ? <FaEye /> : <FaEyeSlash />} {t('status.preview')}
                </Button>
                <Button variant='danger' className='mb-4' onClick={() => setShowConfirm(true)}>
                    <FaTrash /> {t('status.delete')}
                </Button>

                <ConfirmDeleteModal
                    isOpen={showConfirm}
                    onClose={() => setShowConfirm(false)}
                    onConfirm={handleDelete}
                    title='Delete this campaign data?'
                    description='This action cannot be undone. Are you sure you want to delete this campaign data?'
                />
            </div>
            <EditableFormPage
                title='Campaign Details'
                fetchUrl={`admin/newsletter-campaigns/${id}`}
                fields={emailCampaignFields}
                classNameForField={getClassNameForField}
                loadingMessage='Loading information...'
                errorMessage='Failed to fetch data.'
                acceptJSON={true}
                method='PUT'
                previewEmail={preview}
            />
        </>
    )
}

export default NewsletterCampaignSlug
